import vSearch from "./v-search.vue";

export default Vue => {
  Vue.component("v-search", vSearch);
};
